export type RetailChain = {
  id: string
  name: string
  brand_key: string
  country_code: string
  is_active: boolean
}

export const DRIVING_RADIUS_COUNTRIES = new Set(['ZA', 'ZW', 'US', 'CA'])
export const MIN_DRIVING_RADIUS_KM = 25
export const DEFAULT_URBAN_RADIUS_KM = 10

export function searchRadiusForCountry(countryCode: string): number {
  const cc = countryCode.toUpperCase()
  if (DRIVING_RADIUS_COUNTRIES.has(cc)) return MIN_DRIVING_RADIUS_KM
  return DEFAULT_URBAN_RADIUS_KM
}

/** brand_key → name-matching patterns for Google Places detection */
export const CHAIN_DETECTION_PATTERNS: Record<string, RegExp[]> = {
  hofer: [/\bhofer\b/i, /\baldi\b/i],
  billa: [/\bbilla\b/i],
  lidl_at: [/\blidl\b/i],
  checkers: [/\bcheckers\b/i],
  pick_n_pay: [/pick[\s'n-]*pay/i],
  woolworths_za: [/\bwoolworths\b/i],
  spar_za: [/\bspar\b|\beurospar\b/i],
  spar_zw: [/\bspar\b/i],
  tm_pick_n_pay: [/\btm pick\b|\bpick[\s'n-]*pay\b/i],
  bon_marche: [/bon march[eé]/i],
  food_lovers_zw: [/food lover/i],
  lidl: [/\blidl\b/i],
  spar: [/\bspar\b|\beurospar\b/i],
}

export const CHAIN_ICONS: Record<string, string> = {
  hofer: '🛒',
  billa: '🛒',
  lidl_at: '🏪',
  lidl: '🏪',
  checkers: '🛒',
  pick_n_pay: '🛒',
  woolworths_za: '🥬',
  spar_za: '🛒',
  spar_zw: '🛒',
  spar: '🛒',
  tm_pick_n_pay: '🛒',
  bon_marche: '🛒',
  food_lovers_zw: '🥬',
}

export function detectBrandKey(placeName: string, allowedBrandKeys: string[]): string | null {
  for (const brandKey of allowedBrandKeys) {
    const patterns = CHAIN_DETECTION_PATTERNS[brandKey] ?? [new RegExp(brandKey.replace(/_/g, '[\\s-]'), 'i')]
    if (patterns.some((pattern) => pattern.test(placeName))) {
      return brandKey
    }
  }
  return null
}

export function chainIcon(brandKey: string): string {
  return CHAIN_ICONS[brandKey] ?? '🛒'
}
